export const DEFAULT_WIDTH = 550;
export const DEFAULT_MIN_WIDTH = 550;
export const DEFAULT_MIN_HEIGHT = 400;
export const WORKFLOW_NOT_FOUND_CODE = 'WORKFLOW_NOT_FOUND';
